import { ChevronRight } from 'lucide-react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const COLORS = ['#D84D4D', '#F09E2B', '#089B19'];

const data = [
  { name: 'Completed', value: 1 },
  { name: 'Pending', value: 1 },
  { name: 'Expired', value: 1 },
];

const SemiPieChart = () => {
  return (
    <div style={{ width: '100%', height: '100px', position: 'relative' }}>
      {/* Center content inside semi doughnut */}
      <div
        style={{
          position: 'absolute',
          top: '70%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}
      >
        <div className='flex items-start gap-[4px]'>
          <div
            style={{
              fontSize: '32px',
              fontWeight: 'bold',
              letterSpacing: '0.64px',
              lineHeight: '24px',
              color: 'var(--primary-color)',
              textAlign: 'center',
            }}
          >
            675
          </div>
          <ChevronRight className='max-w-[20px]' />
        </div>
      </div>

      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            cx='50%'
            cy='100%'
            startAngle={180}
            endAngle={0}
            innerRadius={70}
            outerRadius={80}
            paddingAngle={0}
            dataKey='value'
            isAnimationActive={true}
          >
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SemiPieChart;
